/**
 * Textos y formatos compartidos por las pantallas del facturador.
 */

export const NOMBRES_TIPO = {
  33: 'Factura',
  34: 'Factura exenta',
  46: 'Factura de compra',
  56: 'Nota de débito',
  61: 'Nota de crédito',
};

/** Tipos que se emiten desde el formulario; las notas salen de anular o corregir. */
export const TIPOS_DIRECTOS = [33, 34, 46];

export const ESTADOS = {
  por_enviar: { texto: 'Pendiente de envío', clase: 'amarillo' },
  enviado: { texto: 'Enviado al SII', clase: 'azul' },
  aceptado: { texto: 'Aceptado', clase: 'verde' },
  aceptado_reparos: { texto: 'Aceptado con reparos', clase: 'amarillo' },
  rechazado: { texto: 'Rechazado', clase: 'rojo' },
};

export const FORMAS_PAGO = { 1: 'Contado', 2: 'Crédito', 3: 'Sin costo' };

/** Lo que puede faltar para emitir, con dónde se completa. */
export const FALTANTES = {
  rut: { texto: 'RUT de la empresa', ruta: '/configuracion' },
  direccion: { texto: 'Dirección de la empresa', ruta: '/configuracion' },
  comuna: { texto: 'Comuna de la empresa', ruta: '/configuracion' },
  giro: { texto: 'Giro del emisor', ruta: '/facturador/configuracion' },
  actividades: { texto: 'Actividades económicas (códigos del SII)', ruta: '/facturador/configuracion' },
  unidad_sii: { texto: 'Oficina del SII', ruta: '/facturador/configuracion' },
  resolucion: { texto: 'Resolución del SII (la registra EFE)', ruta: null },
  certificado: { texto: 'Certificado digital vigente', ruta: '/facturador/configuracion' },
  folios: { texto: 'Folios (CAF) cargados', ruta: '/facturador/configuracion' },
};

/** Datos del receptor que puede pedir la emisión. */
export const CAMPOS_RECEPTOR = {
  razonSocial: 'Razón social',
  giro: 'Giro',
  direccion: 'Dirección',
  comuna: 'Comuna',
};

export const pesos = (valor) => `$${Math.round(Number(valor) || 0).toLocaleString('es-CL')}`;

/** AAAA-MM-DD → DD-MM-AAAA */
export const fechaCorta = (valor) => {
  if (!valor) return '—';
  const [anio, mes, dia] = String(valor).slice(0, 10).split('-');
  return `${dia}-${mes}-${anio}`;
};

export const fechaChile = (valor) =>
  valor ? new Date(valor).toLocaleDateString('es-CL', { timeZone: 'America/Santiago' }) : '—';

/** Fecha de hoy en Chile, AAAA-MM-DD. */
export const hoyChile = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());

export const mensajeError = (error, porDefecto) => error?.response?.data?.message || porDefecto;

export const nombreDocumento = (documento) => `${NOMBRES_TIPO[documento.tipo] || `Documento ${documento.tipo}`} N° ${documento.folio}`;

export const EstadoBadge = ({ estado }) => {
  const info = ESTADOS[estado] || { texto: estado, clase: 'gris' };
  return <span className={`fe-badge fe-badge--${info.clase}`}>{info.texto}</span>;
};

const MESES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

/** El facturador parte en 2026: antes no hay documentos que listar. */
const PRIMER_ANIO = 2026;

/** AAAA-MM → octubre de 2026 */
export const nombreMes = (mes) => `${MESES[Number(mes.slice(5, 7)) - 1].toLowerCase()} de ${mes.slice(0, 4)}`;

/**
 * Listas de año y mes de los filtros. mes es '01'…'12', o '' para todo el año (solo con conTodoElAnio).
 * En el año en curso no se listan meses futuros: no se emite con fecha futura.
 */
export const FiltroPeriodo = ({ anio, mes, onCambio, conTodoElAnio = false, disabled = false }) => {
  const hoy = hoyChile();
  const anios = [];
  for (let a = Number(hoy.slice(0, 4)); a >= PRIMER_ANIO; a -= 1) anios.push(String(a));
  const meses = anio === hoy.slice(0, 4) ? MESES.slice(0, Number(hoy.slice(5, 7))) : MESES;

  // Al volver al año en curso desde un mes que todavía no llega, queda el mes actual
  const cambiarAnio = (nuevo) => onCambio(nuevo, nuevo === hoy.slice(0, 4) && mes > hoy.slice(5, 7) ? hoy.slice(5, 7) : mes);

  return (
    <>
      <div className="fe-form-group">
        <label>Año</label>
        <select value={anio} onChange={(e) => cambiarAnio(e.target.value)} disabled={disabled}>
          {anios.map((a) => <option key={a} value={a}>{a}</option>)}
        </select>
      </div>
      <div className="fe-form-group">
        <label>Mes</label>
        <select value={mes} onChange={(e) => onCambio(anio, e.target.value)} disabled={disabled}>
          {conTodoElAnio && <option value="">Todo el año</option>}
          {meses.map((nombre, i) => <option key={nombre} value={String(i + 1).padStart(2, '0')}>{nombre}</option>)}
        </select>
      </div>
    </>
  );
};
